export default "__VITE_ASSET__tqAU2Zku__"